<script setup>
import { useAppStore } from '@/stores/App'

// Vars
const app = useAppStore()
// const staticURLImg = useRuntimeConfig().public.staticURLImg

function scrollToSection(id) {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
}

// SEO
useSeoMeta({
    title: 'Services',
    ogTitle: 'Services',
    description: 'satYatunes offers UI/UX, Sound, Website and Blog design services.',
    ogDescription: 'satYatunes offers UI/UX, Sound, Website and Blog design services.',
})

/* useHead({
    link: [
        {
            rel: 'preload',
            as: 'image',
            href: staticURLImg + 'exui-sm1-white.webp',
        },
    ],
}) */
</script>

<template>
    <v-row id="services" class="d-flex flex-column align-center">
        <v-col cols="12">
            <v-row no-gutters class="mt-4 mb-6 justify-center">
                <v-col cols="12" class="text-center">
                    <v-hover v-for="chip in app.servicesChips" :key="chip.text" v-slot="{ isHovering, props }">
                        <v-chip
                            v-bind="props"
                            density="compact"
                            :color="isHovering ? 'secondary' : undefined"
                            class="mx-2 my-1 font-weight-medium text-button"
                            @click="scrollToSection(chip.section)"
                            size="large"
                            :aria-label="`Go to ${chip.section} section`"
                        >
                            {{ chip.text }}
                        </v-chip>
                    </v-hover>
                </v-col>
            </v-row>

            <app-section-gui-design />

            <app-section-kontakt />

            <app-section-custom-gui />

            <app-section3d />

            <!-- <app-section-cover-arts /> -->

            <app-section-sound-design />

            <app-section-web-design />

            <the-testimonials />

            <the-clients />
        </v-col>
    </v-row>
</template>

<style scoped></style>
